module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "pull-right"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.showPrev) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.action(_vm.page - 1)
      }
    }
  }, [_c('a', [_vm._v("«")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pages), function(i) {
    return _c('li', {
      class: {
        active: _vm.page == i
      },
      on: {
        "click": function($event) {
          return _vm.action(i)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(i))])])
  }), _vm._v(" "), (_vm.showNext) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.action(_vm.page + 1)
      }
    }
  }, [_c('a', [_vm._v("»")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ccecc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/pagination.vue
// module id = 208
// module chunks = 1